export default {
    id: "73a0eeca-0072-40cc-8162-18881d2c0e2d",
    icon: "mdi-chevron-right",
    name: "breadcrumb",
    title: "Breadcrumb",
    description: "LessonPlan Breadcrumb",
}